
import {
    Vue,
    Component,
    Prop,
    Emit,
    Watch,
} from 'vue-property-decorator';

@Component({
    name: 'CouponPicker',
    components: {},
})
export default class CouponPicker extends Vue {
    @Prop({
        type: Array,
        default() {
            return [];
        },
    })
    private coupon!: any[];

    @Prop({
        type: Array,
        default() {
            return [];
        },
    })
    private rebate!: any[];

    @Prop({
        type: Number,
        default: 0,
    })
    private parkId!: number;

    @Prop({
        type: String,
        default: 'coupon',
    })
    private tabName!: 'coupon' | 'rebate';

    @Prop({
        type: Boolean,
        default: false,
    })
    private visible!: boolean;

    private currentTab: string = this.tabName;

    get supportRebate() {
        return !!this.$store.state.park.is_platform_coupon;
    }

    get supportCoupon() {
        return !!this.$store.state.park.is_merchant_coupon;
    }

    get parkName() {
        return this.$store.state.park.name;
    }

    @Watch('tabName')
    public tabNameChange(n: any, o: any) {
        if (n !== o) {
            this.currentTab = n;
        }
    }

    @Emit('update:visible')
    public visibleChange(status: boolean) {
        return status;
    }

    @Emit('coupon-select')
    public onCouponSelect(item: any) {
        this.visibleChange(false);
        return item;
    }

    @Emit('rebate-select')
    public onRebateSelect(item: any) {
        this.visibleChange(false);
        return item;
    }
}
